import {LocaleType} from 'src/types/utils'

export const LOCALE_EN: LocaleType = 'en' as const
export const LOCALE_FR: LocaleType = 'fr' as const
export const DEFAULT_LOCALE: LocaleType = LOCALE_FR
export const LANGUAGE_EN = 'English' as const
export const LANGUAGE_FR = 'French' as const
